import { REGEX_URL_NAME } from '@/constants/constants';


export default {
  name: 'SignInSuccess',

  mounted() {
    if (this.$store.getters.redirectUri) {
      this.redirectUri = this.$store.getters.redirectUri;
    }
  },

  computed: {
    redirectUriName() {
      const splitedUri = this.redirectUri.match(REGEX_URL_NAME);
      if (splitedUri) {
        return splitedUri[3];
      }

      return process.env.VUE_APP_MOTMOM_URL.match(REGEX_URL_NAME)[3];
    },
  },

  methods: {
    signOut() {
      clearInterval(this.localTimerId);
      this.$emit('onSignOut');
    },

    setTimer() {
      this.localTimerId = setInterval(
        () => {
          this.timeOut -= 1;

          if (this.timeOut === 0) {
            clearInterval(this.localTimerId);
            window.location.href = this.redirectUri;
          }
        },
        1000,
      );
    },
  },

  created() {
    this.timeOut = 5;
    this.setTimer();
  },

  beforeDestroy() {
    clearInterval(this.localTimerId);
  },

  data() {
    return {
      redirectUri: process.env.VUE_APP_MOTMOM_URL,
    };
  },
};
